/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useTradeOrganizationContext } from "../../../../context/tradeOrganization/TradeOrganizationContext";
import {
  Title,
  GoBack,
  TextArea,
  InputField,
  MyMessage,
  MyActionButton,
} from "../../component/Component";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { FOLDERS } from "../../../doseeData/utils/Utils";
import {
  AiFillBuild,
} from "react-icons/ai";
import {
  FiGlobe,
  FiMapPin,
  FiCalendar,
  FiTarget,
  FiFlag,
  FiEye,
  FiInfo,
  FiImage,
} from "react-icons/fi";

const Add = () => {
  const { createOneTradeOrganization } = useTradeOrganizationContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [name, setName] = useState(null);
  const [acronym, setAcronym] = useState(null);
  const [headquarters, setHeadquarters] = useState(null);
  const [objectives, setObjectives] = useState(null);
  const [debuted_on, setDebutedOn] = useState(null);
  const [mission, setMission] = useState(null);
  const [vision, setVision] = useState(null);

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [website, setWebsite] = useState(null);

  const [description, setDescription] = useState(null);

  const tradeOrganizationRoutes = "/trade/org";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setName(null);
    setAcronym(null);
    setHeadquarters(null);
    setObjectives(null);
    setDebutedOn(null);
    setMission(null);
    setVision(null);
    setDescription(null);
    setThumbnail(defaultImage);
    setThumbnailId("image_cdn_id");
    setWebsite(null);
  };

  const responses = (isError, msg) => {
    setError(isError);
    setSuccess(!isError);
    setLoading(false);
    setErrorMessage(msg);
  };

  const addOneTradeOrganizationHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      name,
      acronym,
      headquarters,
      chief_officer: "...",
      objectives,
      debuted_on,
      mission,
      vision,
      description,
      thumbnail,
      image_cdn_id: thumbnailId,
      website,
    };

    const { status } = await createOneTradeOrganization(data);
    if (status === 200) {
      cleanFields();
      responses(false, message);
    } else {
      setLoading(false);
      responses(true, message);
    }
  };

  return (
    <div className="h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50 p-4">
      <GoBack props={{ route: tradeOrganizationRoutes }} />

      <form onSubmit={addOneTradeOrganizationHandler} className="mx-auto mt-2 max-w-6xl">
        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-3 px-5 py-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                <AiFillBuild className="h-5 w-5" />
              </span>
              <div>
                <div className="text-sm font-semibold tracking-tight text-gray-900">
                  Create Trade Organization
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px]">
                  <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 font-semibold text-emerald-700">
                    <FiInfo className="h-3.5 w-3.5" />
                    Fill details then save
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 font-semibold text-gray-700">
                    <FiImage className="h-3.5 w-3.5" />
                    Logo required
                  </span>
                </div>
              </div>
            </div>

            <div className="text-[11px] text-gray-600">
              Keep names short; use official acronyms where possible.
            </div>
          </div>

          <div className="px-5 pb-5">
            <div className="mb-4">
              <MyMessage
                error={error}
                message={message}
                success={success}
                onExpired={() => {
                  setError(false);
                  setSuccess(false);
                }}
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage("");
                }}
              />
            </div>

            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
              <div className="lg:col-span-1">
                <div className="rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm">
                  <div className="mb-3 flex items-center justify-between">
                    <div className="text-sm font-semibold text-gray-900">Organization Logo</div>
                    <span className="rounded-md border border-gray-200 bg-gray-100 px-2 py-[2px] text-[10px] font-semibold text-gray-700">
                      PNG/JPG
                    </span>
                  </div>
                  <ImageKitUpload
                    thumbnail={thumbnail}
                    thumbnailId={thumbnailId}
                    setThumbnail={setThumbnail}
                    setThumbnailId={setThumbnailId}
                    folder={FOLDERS.TRADE_ORGANIZATIONS}
                  />
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm">
                  <Title props={{ title: "Trade Organization Details" }} />

                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <AiFillBuild className="h-4 w-4 text-gray-600" />
                        Name
                      </label>
                      <InputField
                        props={{
                          id: "title",
                          title: "Name",
                          type: "text",
                          required: true,
                          value: name ? name : "",
                          onChange: (e) => {
                            setName(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>

                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiFlag className="h-4 w-4 text-gray-600" />
                        Acronym
                      </label>
                      <InputField
                        props={{
                          id: "acronym",
                          title: "Acronym",
                          type: "text",
                          value: acronym ? acronym : "",
                          onChange: (e) => {
                            setAcronym(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>

                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiGlobe className="h-4 w-4 text-gray-600" />
                        Website
                      </label>
                      <InputField
                        props={{
                          id: "website",
                          title: "Website",
                          type: "text",
                          value: website ? website : "",
                          onChange: (e) => {
                            setWebsite(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                      <p className="mt-1 text-[11px] text-gray-500">Include protocol e.g. https://example.org</p>
                    </div>

                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiMapPin className="h-4 w-4 text-gray-600" />
                        Headquarters
                      </label>
                      <InputField
                        props={{
                          id: "headquarters",
                          title: "Headquarters",
                          type: "text",
                          value: headquarters ? headquarters : "",
                          onChange: (e) => {
                            setHeadquarters(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>

                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiCalendar className="h-4 w-4 text-gray-600" />
                        Debuted On
                      </label>
                      <InputField
                        props={{
                          id: "debuted_on",
                          title: "Debuted On",
                          type: "text",
                          value: debuted_on ? debuted_on : "",
                          onChange: (e) => {
                            setDebutedOn(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                      <p className="mt-1 text-[11px] text-gray-500">Format suggestion: YYYY-MM-DD</p>
                    </div>
                  </div>

                  <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiTarget className="h-4 w-4 text-gray-600" />
                        Objectives
                      </label>
                      <TextArea
                        props={{
                          id: "objectives",
                          title: "Objectives",
                          type: "text",
                          value: objectives ? objectives : "",
                          onChange: (e) => {
                            setObjectives(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>

                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiFlag className="h-4 w-4 text-gray-600" />
                        Mission
                      </label>
                      <TextArea
                        props={{
                          id: "mission",
                          title: "Mission",
                          type: "text",
                          value: mission ? mission : "",
                          onChange: (e) => {
                            setMission(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>

                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiEye className="h-4 w-4 text-gray-600" />
                        Vision
                      </label>
                      <TextArea
                        props={{
                          id: "vision",
                          title: "Vision",
                          type: "text",
                          value: vision ? vision : "",
                          onChange: (e) => {
                            setVision(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>

                    <div>
                      <label className="mb-1 flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiInfo className="h-4 w-4 text-gray-600" />
                        Description
                      </label>
                      <TextArea
                        props={{
                          id: "description",
                          title: "Description",
                          type: "text",
                          required: true,
                          value: description ? description : "",
                          onChange: (e) => {
                            setDescription(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="mt-6 flex items-center justify-end border-t border-gray-100 pt-4">
                    <MyActionButton
                      loading={loading}
                      title="Add Trade Organization"
                      onClick={() => {
                        setError(false);
                        setSuccess(false);
                        setErrorMessage(null);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Add;
